import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-bulk-listing';

export default function Example() {
  return (
    <>
      <Head>
        <title>eBay Bulk Listing Tool: The Quickest Way to List All Your Items</title>
        <meta
          name='description'
          content='Save time and achieve your sales goals quickly by listing hundreds of products all at once using the eBay bulk listing tool!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-bulk-listing' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-bulk-listing' />
        <meta property='og:title' content='eBay Bulk Listing Tool: The Quickest Way to List All Your Items' />
        <meta
          property='og:description'
          content='Save time and achieve your sales goals quickly by listing hundreds of products all at once using the eBay bulk listing tool!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-05-29T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-05-29T00:00:00-00:00' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
